import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'operating-systems',
    pluginName: 'SETTINGS',
    entityName: 'OPERATING_SYSTEM',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch operating systems action creators
export const fetchOperatingSystemInit = () => {
    return crudActions.fetchInit();
};
export const fetchOperatingSystemStart = () => {
    return crudActions.fetchStart();
};
export const fetchOperatingSystemSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchOperatingSystemFail = () => {
    return crudActions.fetchFail();
};
export const fetchOperatingSystemCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchOperatingSystemStart());
        try {
            let countRes = await rest.post("operating-systems/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchOperatingSystemSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchOperatingSystemFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch operating systems."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchOperatingSystemFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch operating systems."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchOperatingSystem = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchOperatingSystemStart());
        try {
            let listRes = await rest.post("operating-systems/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchOperatingSystemSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchOperatingSystemFail());
            return []

        } catch (error) {
            dispatch(fetchOperatingSystemFail());
            return []
        }
    }
}

// Load operating system action creators
export const loadOperatingSystemInit = () => {
    return crudActions.loadInit();
};
export const loadOperatingSystemStart = () => {
    return crudActions.loadStart();
};
export const loadOperatingSystemSuccess = loadedOperatingSystem => {
    return crudActions.loadSuccess(loadedOperatingSystem);
};
export const loadOperatingSystemFail = error => {
    return crudActions.loadFail(error);
};
export const loadOperatingSystem = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

export const createOperatingSystem = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/operating-systems/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created operating system.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create operating system."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const editOperatingSystem = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/operating-systems/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated operating system.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit operating system."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete operating systems action creators
export const bulkDeleteOperatingSystemsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteOperatingSystemsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteOperatingSystemsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteOperatingSystemsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteOperatingSystems = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteOperatingSystemsStart());
        try {
            let res = await rest.post('/operating-systems/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteOperatingSystemsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted operating systems.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteOperatingSystemsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete operating systems."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete operating systems."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteOperatingSystemsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};